import Stack from '@mui/material/Stack';
import HeighestLeadFooterSection from './HeighestLeadFooterSection';
import SpannedTable from './SpannedTable';
import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { getMonthWiseCsdData, getSourceWiseData } from '../../../redux/features/CRDslice';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';

export default function CsdFooterGraphAndTable() {
  const [year, setYear] = useState(dayjs().year());
  const dispatch = useDispatch();
  const leadExpenseDashboardCards = useSelector((state) => state.crd.leadExpenseDashboardCards.data ?? {});

  // filtered useEffect
  useEffect(() => {
    const highest_user_id = leadExpenseDashboardCards?.highest_user_id;

    if (!highest_user_id) return;
    const monthWiseRes = dispatch(getMonthWiseCsdData({ highest_user_id, year }));
    const sourceWiseRes = dispatch(getSourceWiseData({ highest_user_id, year }));
    return () => {
      monthWiseRes.abort();
      sourceWiseRes.abort();
    };
  }, [year, dispatch, leadExpenseDashboardCards]);
  return (
    <Stack gap={2}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          views={['year']}
          label="year"
          sx={{ maxWidth: 180 }}
          onChange={(v) => setYear(v?.isValid() ? v?.year() : null)}
          value={year ? dayjs().year(year) : year}
        />
      </LocalizationProvider>
      <Stack direction={{ xs: 'column', lg: 'row' }} justifyContent={'space-between'} gap={1}>
        <HeighestLeadFooterSection />
        <SpannedTable />
      </Stack>
    </Stack>
  );
}
